import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BACKEND_API_URL } from "../../config";

const initialState = {
  data: {
      sign_option: '',
      logo_option: '',
      _image: null,
      logo_link: '',
    }, 
  status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
  loading: false,
  error: null,
}

export const fetchInitialState = createAsyncThunk(
  'MortgageSign/fetch', 
  async (data, { getState, dispatch }) => {
    const {token} = getState().navigator;
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/mortgage_sign?token=${token}`);
        if (!response.ok) {
          throw new Error('Failed to fetch initial state');
        }
        const initialState = await response.json();
        // console.log(initialState);
        return initialState;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return initialState.data
      }
  })



// Create New 
export const SubmitMortgageSign = createAsyncThunk(
    'MortgageSign/submit',
    async (data, { getState, dispatch, rejectWithValue }) => {
        try {
          // Add userId to the data
          const {token} = getState().navigator;
          if (data.sign_option === '') {
              return rejectWithValue('Please select the option.');
          }

          if (data.sign_option === 'Yes' && (!data._image || data._image === 'null')) {
              // alert("Please upload the picture of your Sign!");
              return rejectWithValue('Please upload the picture of your Sign!');
          }

          // console.log(data);
          if (data.sign_option === 'No' && data.logo_option === '') {
            return rejectWithValue('Please select an option for Rize Logo!');
          }
          // because of Image, send as FormData
          const formData = new FormData();
            Object.keys(data).forEach((key) => {
              formData.append(key, data[key]);
          });

          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/mortgage_sign?token=${token}`, {
              method: 'POST',
              body: formData
          });
          const response_data =  await response.json();
          // Handle the response data
          // console.log('Form submitted successfully', response_data);
    
          return response_data.data;
        } catch (error) {
          // Handle submission errors
          console.error('Form submission error', error);
          // Throw an error for the rejected action
          return error;
        }
      }
)


// Slice

export const mortgageSignSlice = createSlice({
    name: 'MortgageSign',
    initialState,
    reducers: {
      updateMortgageSignOption: (state, action) => {
        state.data.sign_option = action.payload;
        if (action.payload !== 'No') state.data.logo_option = ''
      },
      updateMortgageLogoOption: (state, action) => {
        state.data.logo_option = action.payload;
      },
    },
    extraReducers: (builder) => {
        builder
          // FETCH
          // CREATE or UPDATE
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // CREATE or UPDATE
          .addCase(SubmitMortgageSign.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitMortgageSign.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(SubmitMortgageSign.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
      },
  });


export const { updateMortgageSignOption, updateMortgageLogoOption } = mortgageSignSlice.actions;

export default mortgageSignSlice.reducer;
  